/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import PropTypes from "prop-types";
import format from "date-fns/format";
import "./subscription-details.m.css";
import { CustomLink } from "../../custom-link";

const TableHeader = () => {
  return (
    <div styleName="plan-details">
      <div styleName="content subs-detail-placeholder">Plan Name</div>
      <div styleName="content space subs-detail-placeholder">Start date</div>
      <div styleName="content subs-detail-placeholder">End date</div>
    </div>
  );
};

const NoSubscriptionMessage = () => {
  return (
    <div styleName="no-subs">
      <h3 styleName="no-subs-head">No Subscriptions</h3>
      <p styleName="no-subs-content">
        Subscribe to become prime member and get unlimited access to our exclusive stories.
      </p>
      <div styleName="no-subs-btn">
        <CustomLink href={"/subscription"}>Subscribe now</CustomLink>
      </div>
    </div>
  );
};

const SubscriptionList = ({ plans }) => {
  return plans.map(plan => {
    const { id, plan_name: planName, start_timestamp: startDate, end_timestamp: endDate } = plan;
    return (
      <div key={id} styleName="plan-details">
        <div styleName="content">{planName}</div>
        <div styleName="content space">{format(startDate, "DD MMM, YYYY")}</div>
        <div styleName="content">{format(endDate, "DD MMM, YYYY")}</div>
      </div>
    );
  });
};

SubscriptionList.propTypes = {
  plans: PropTypes.array
};

const SubscriptionsTable = ({ heading, plans }) => {
  return (
    <div styleName="list">
      <h3 styleName="table-heading">{heading}</h3>
      <TableHeader />
      <SubscriptionList plans={plans} />
    </div>
  );
};

SubscriptionsTable.propTypes = {
  heading: PropTypes.string,
  plans: PropTypes.array
};

const SubscriptionsBlock = ({ subscriptions }) => {
  const expiredPlans = subscriptions.filter(
    plan => plan.status === "expired" && plan["subscription_type"] === "standard"
  );
  const activeplans = subscriptions.filter(
    plan =>
      (plan.status === "active" && plan["subscription_type"] === "standard") ||
      (plan.status === "pending" && plan["subscription_type"] === "standard")
  );

  if (!activeplans.length && !expiredPlans.length) return <NoSubscriptionMessage />;
  return (
    <>
      {!!activeplans.length && <SubscriptionsTable heading="Active Subscriptions" plans={activeplans} />}
      {!!expiredPlans.length && <SubscriptionsTable heading="Expired Subscriptions" plans={expiredPlans} />}
    </>
  );
};

SubscriptionsBlock.propTypes = {
  subscriptions: PropTypes.array
};

export { SubscriptionsBlock };
